import React, { useContext, useEffect } from 'react';

import { useFileManagerContext } from 'modules/file_manager/context/FileManagerContext';
import CaseListDropDown from 'components/CaseListDropDown/CaseListDropDown';
import { UserDetailsContext } from 'context/userDetailsContext';
import { convertCaseToFilterFormat } from 'utils/utils';

function CaseFilter() {
  const { fileManagerFilters, onFilterChange, isClientFileManager, setBreadCrumbs, setSelectedRows } = useFileManagerContext();
  const userContext = useContext(UserDetailsContext);

  function clearBreadcrumbs() {
    setBreadCrumbs([]);
  }

  useEffect(() => {
    // Only set the filter if:
    // 1. It's client file manager
    // 2. clientSelectedCase exists
    // 3. No case is currently selected in filters (to prevent overriding user selection)
    if (isClientFileManager && userContext?.clientSelectedCase && !fileManagerFilters?.case?.id) {
      onFilterChange(
        {
          target: {
            name: 'case',
            value: convertCaseToFilterFormat(userContext?.clientSelectedCase) || '',
          },
          value: convertCaseToFilterFormat(userContext?.clientSelectedCase) || '',
        },
        setBreadCrumbs
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userContext?.clientSelectedCase, isClientFileManager, fileManagerFilters?.case?.id]);

  return (
    <div className="filter-wraper">
      {isClientFileManager && userContext?.clientCaseList.length > 1 && (
        <CaseListDropDown
          isClient={isClientFileManager}
          value={fileManagerFilters?.case}
          onChange={(e) => {
            if (fileManagerFilters?.case !== e) {
              onFilterChange({ target: { name: 'case', value: e }, value: e }, clearBreadcrumbs);
              setSelectedRows([]);
            }
          }}
          name="case"
          selectFirstOption
          excludeFromLoading={true}
        />
      )}
      {!isClientFileManager && (
        <CaseListDropDown
          isClient={isClientFileManager}
          placeholder="By Case/Lead"
          value={fileManagerFilters?.case}
          onChange={(e) => {
            if (fileManagerFilters?.case !== e) {
              onFilterChange({ target: { name: 'case', value: e }, value: e }, clearBreadcrumbs);
              setSelectedRows([]);
            }
          }}
          noOptionsMessage="No Cases/Leads Found"
          name="case"
          isClearable
          excludeFromLoading={true}
        />
      )}
    </div>
  );
}

export default CaseFilter;
